<div class="row">
  <div class="col-md-12">
    <div>
      <a [href]="apiDocAddress" target="_blank">Smoothiz API documentation</a>
    </div>
    <div class="form-group label-floating">
      <label class="control-label">Select release note</label>
      <div class="btn-group">
        <button class="btn btn-raised primary" [ngClass]="{'active': displayFrontRelease==false}"
          (click)="displayFrontRelease = false">
          <input type="radio" autocomplete="off"> Back end
        </button>
        <button class="btn btn-raised primary" [ngClass]="{'active': displayFrontRelease==true}"
          (click)="displayFrontRelease = true">
          <input type="radio" autocomplete="off"> Front end
        </button>
      </div>
    </div>
  </div>
</div>

@if (!displayFrontRelease) {
  <div [ngClass]="{'release-template': !displayFrontRelease}"
  [innerHTML]="backEndReleaseNote"></div>
}
@if (displayFrontRelease) {
  <div class="release-content">
    <h2>2026-08-01: 4.1.0</h2>
    <ul class="a">
      <li>Dashboard: Display days outside Luxembourg and quota</li>
      <li>Time Management: Home-based working becomes Outside Lux</li>
    </ul>
    <h2>2026-03-20: 4.0.0</h2>
    <ul class="a">
      <li>Dashboard: Display part-time information and configuration</li>
      <li>Time Management: Weekends displayed in calendar</li>
      <li>Timesheet Check: Rework of the TSCheck component</li>
      <li>Timesheet Check: Display ITz by mission for admin</li>
      <li>Planning: Rework component</li>
      <li>Event Management: Rework component</li>
      <li>User Administration: Display ITz mission</li>
      <li>User Administration: Fix user creation</li>
    </ul>
    <b>Technical release</b>
    <ul class="a">
      <li>Upgrade to Angular 21.2.0</li>
      <li>Upgrade to Node.js 22.17.1</li>
      <li>Standalone architecture migration</li>
      <li>Remove Bootstrap 3, jQuery and Angular Material</li>
      <li>Signals and OnPush change detection strategy</li>
    </ul>
    <h2>2025-06-20: 3.2.0</h2>
    <ul class="a">
      <li>Timesheet: Customize approver name</li>
      <li>AdminComponent: Save seniority dates</li>
    </ul>
    <h2>2025-02-27: 3.1.3</h2>
    <ul class="a">
      <li>Timesheet: new format</li>
      <li>Bug Fixing: Issue when creating an event on public holiday</li>
    </ul>
    <h2>2024-12-03: 3.1.2</h2>
    <ul class="a">
      <li>Time management: Event creation date time limit set to end of N+1 year</li>
    </ul>
    <h2>2024-09-09: 3.1.1</h2>
    <ul class="a">
      <li>Bug Fixing: Issue on Dashboard for part time users</li>
    </ul>
    <h2>2024-04-28: 3.1.0</h2>
    <ul class="a">
      <li>Techradar: "Interested" is not a skill level anymore</li>
      <li>Timesheet Check: Prevent some profiles to display billing times in days</li>
      <li>Timesheet Check: Timesheet generator</li>
      <li>Bug Fixing: Issue when EDITING an existing event</li>
    </ul>
    <h2>2024-01-01: 3.0.0</h2>
    <ul class="a">
      <li>New kind of events: Kids Sickness</li>
      <li>Dashboard: Display Sickness days</li>
      <li>Dashboard: Display Kids Sickness days</li>
      <li>Dashboard: Add a link to the Xpertiz documentation</li>
      <li>Time Management: New calendar display (Month, Year, 4 months)</li>
      <li>Time Management: Handle days off for part time ITz</li>
      <li>Timesheet Check: Display time in days or hours</li>
      <li>Timesheet Check: Handle days off for part time ITz</li>
    </ul>
    <b>Technical release</b>
    <ul class="a">
      <li>Upgrade to Angular 16.2.12</li>
      <li>Upgrade to FullCalendar 6.1.9</li>
    </ul>
    <h2>2022-06-29: 2.8.0</h2>
    <ul class="a">
      <li>New kind of events: Home based working</li>
    </ul>
    <h2>2020-10-12: 2.7.0</h2>
    <b>Bug Fixing</b>
    <ul class="a">
      <li>Admin: Tech radars</li>
    </ul>
    <h2>2020-09-01: 2.6.0</h2>
    <ul class="a">
      <li>New Component: Tech radar</li>
    </ul>
    <h2>2019-10-15: 2.5.1</h2>
    <b>Technical release</b>
    <ul class="a">
      <li>Split event types and balance types</li>
    </ul>
    <h2>2019-09-04: 2.5.0</h2>
    <ul class="a">
      <li>New Component: Planning</li>
      <li>Admin: improve social events creation</li>
      <li>Admin: prepare social events update</li>
      <li>Admin may send Slack notification</li>
    </ul>
    <h2>2019-05-18: 2.4.1</h2>
    <ul class="a">
      <li>Bug Fixing</li>
      <li>UserAdministration: Wrong values in balance type select list</li>
    </ul>
    <h2>2019-05-01: 2.4.0</h2>
    <ul class="a">
      <li>Avatar size is now limited to 60kb</li>
      <li>Date picker: days in other months shown before or after the current month are now selectable</li>
      <li>Directory: Add Itz status (Available, Off)</li>
      <li>Improve Admin Component: Event administration</li>
      <li>API Refactoring</li>
      <li>Deprecate Angular2-JWT</li>
      <li>Improve http errors handler and http requests</li>
    </ul>
    <h2>2019-04-05: 2.3.0</h2>
    <ul class="a">
      <li>SMOOTHIZ-127: Authentication with login or mail address</li>
      <li>Improve Admin Component: User management</li>
      <li>Change backend address</li>
      <li>Display release backend release note</li>
      <li>Change password generation: no special characters anymore</li>
    </ul>
    <h2>2018-09-14: 2.2.0</h2>
    <ul class="a">
      <li>New Component: Provisional schedule</li>
      <li>Bug Fixing</li>
      <li>SMOOTHIZ-123: No Dashboard displayed when a variable is set to 0</li>
    </ul>
    <h2>2018-01-23: 2.1.0</h2>
    <ul class="a">
      <li>New user role (EventManager) with specific rights</li>
      <li>Bug Fixing</li>
      <li>SMOOTHIZ-113: Display error in admin overview</li>
    </ul>
    <h2>2017-12-27: 2.0.0</h2>
    <ul class="a">
      <li>Refactoring Dashboard</li>
      <li>Manage event invitation from the Dashboard</li>
      <li>New Component: Release note</li>
      <li>Refactoring TSCheck (BETA)</li>
      <li>New Component: Tutorials (BETA)</li>
      <li>New Admin Component: User management</li>
      <li>New Admin Component: Planning</li>
      <li>SMOOTHIZ-18: Upload an avatar image</li>
      <li>SMOOTHIZ-58: ITz search in Directory</li>
      <li>SMOOTHIZ-72: Search field in Time Management</li>
    </ul>
    <b>Bug Fixing</b>
    <ul class="a">
      <li>SMOOTHIZ-59: Display active status on navbar items</li>
      <li>SMOOTHIZ-66: [DASHBOARD] Balance values are not well rounded</li>
      <li>SMOOTHIZ-67: Issue with Material Icon on Internet Explorer/Firefox/Edge</li>
      <li>SMOOTHIZ-70: [DASHBOARD] Wrong result displayed in "Next holiday" and "Next event"</li>
      <li>SMOOTHIZ-71: Set event description in input modal</li>
      <li>SMOOTHIZ-78: Dashboard chart is not clear with mobile device</li>
      <li>SMOOTHIZ-80: Issue when closing the Event Modal with Firefox on Android</li>
      <li>SMOOTHIZ-84: Wrong user-first-initial CSS class</li>
      <li>SMOOTHIZ-89: Prevent hardcoded years values</li>
    </ul>
    <b>Technical release</b>
    <ul class="a">
      <li>Upgrade to Angular 5.1.2</li>
      <li>Split Admin services/ITz services</li>
      <li>Improve try/catch blocks in services</li>
      <li>Improve error messages display</li>
    </ul>
    <h2>2017-08-14: 1.2.1</h2>
    <ul class="a">
      <li>SMOOTHIZ-44: New Admin Component: Event management</li>
    </ul>
    <b>Technical release</b>
    <ul class="a">
      <li>Minor fixes with social events display</li>
      <li>Refactoring of all services</li>
    </ul>
    <h2>2017-06-15: 1.1.0</h2>
    <ul class="a">
      <li>Dashboard refactoring</li>
    </ul>
    <h2>2017-06-12: 1.0.0</h2>
    <b>Initial version</b>
  </div>
}
